import { SaleOrderStatusEnum } from '@/types'

export const isSaleOrderEditable = (
  saleOrderStatus?: keyof typeof SaleOrderStatusEnum,
) => {
  const noEditableStatuses = [
    SaleOrderStatusEnum.reviewed,
    SaleOrderStatusEnum.completed,
    SaleOrderStatusEnum.cancelled,
  ]

  return !noEditableStatuses.includes(saleOrderStatus as SaleOrderStatusEnum)
}
